import { applyMiddleware, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'

import monitorReducersEnhancer from '../enhancers/monitorReducer'
import loggerMiddleware from '../middleware/logger'
import getRootReducer from "../reducers";

export default function configureStore(preloadedState) {

  const middlewares = [
    loggerMiddleware,
    thunkMiddleware
  ]

  const middlewareEnhancer =
    applyMiddleware(...middlewares)

  const enhancers = [
    middlewareEnhancer,
    monitorReducersEnhancer
  ]

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const composedEnhancers =
    composeEnhancers(...enhancers)

  const rootReducer = getRootReducer()

  const store = createStore(
    rootReducer,
    preloadedState,
    composedEnhancers
  )

  if (
    process.env.NODE_ENV !== 'production' &&
    module.hot
  ) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(getRootReducer())
    })
  }

  return store
}